import React from "react";
import RoomCard from "./roomCard";
import {cardTypes} from "./types";

const CheckOutCard = ({
    propertyName,
    propertyId,
    roomNumber,
    id,
    roomStatus,
    roomTypeName,
    tasks,
    content,
    nextArrivalTime,
    currentArrivalTime,
    currentDepartureTime,
    vacant,
    markAsDoNotDisturb,
}) => {
    const showStartToCleanBtn = !!tasks && tasks.length > 0;
    const disableStartToCleanBtn = !vacant;

    return (
        <RoomCard roomNumber={roomNumber}
                  tasks={tasks}
                  showHeaderButton={showStartToCleanBtn}
                  content={content}
                  nextArrivalTime={nextArrivalTime}
                  currentArrivalTime={currentArrivalTime}
                  currentDepartureTime={currentDepartureTime}
                  showStartToCleanBtn={showStartToCleanBtn}
                  disableStartToCleanBtn={disableStartToCleanBtn}
                  typeName={cardTypes.CHECKOUT_CLEANINGS}
                  propertyName={propertyName}
                  propertyId={propertyId}
                  roomStatus={roomStatus}
                  roomTypeName={roomTypeName}
                  id={id}
                  vacant={vacant}
                  markAsDoNotDisturb={markAsDoNotDisturb}
        />
    )
};

export default CheckOutCard;